<template>
	<div class="services__content">
		<section class="banner">
			<div class="banner__text wrapper">
				<p class="banner__text--underline">
					<transition name="text-reveal" appear>
						<span class="banner__text--animateOpacity"> Services </span>
					</transition>
				</p>

				<h1 class="banner__text--header">
					<transition name="text-reveal" appear>
						<span class="banner__text--animateOpacity">Offshore service </span>
					</transition>
				</h1>
				<!-- <p class="banner__text--subheader">
					<transition name="text-reveal" appear>
						<span class="banner__text--animateOpacity">
							オフショア(Offshore)とは、岸(shore)から離(off)れ海に流れる風という意味で、つまり「陸
							風」のこと。IT業界では、国内を拠点としていたシステム開発・管理・運用を海外に移転してコス
							ト削減を実現するオフショアサービスを起用している会社が最近増えています。<br />
							弊社は、日本優秀企業で長年経験したフィリピン出身のディレクター（日本在住）を中心と
							し、上流工程は安心できる日本で、量産展開はコスト削減できるフィリピンで行い、日本国内の
							企業さま向けに納得できるコストで安定したWEBサイトの実現をご支援いたします。
						</span>
					</transition>
				</p> -->
			</div>
			<ServicesBackgroundBanner />
		</section>
		<section class="services__offshore">
			<p>
				オフショア(Offshore)とは、岸(shore)から離(off)れ海に流れる風という意味で、つまり「陸
				風」のこと。IT業界では、国内を拠点としていたシステム開発・管理・運用を海外に移転してコス
				ト削減を実現するオフショアサービスを起用している会社が最近増えています。
			</p>
			<p>
				弊社は、日本優秀企業で長年経験したフィリピン出身のディレクター（日本在住）を中心と
				し、上流工程は安心できる日本で、量産展開はコスト削減できるフィリピンで行い、日本国内の
				企業さま向けに納得できるコストで安定したWEBサイトの実現をご支援いたします。
			</p>
		</section>
		<section class="services__info wrapper"><ServicesProcess /></section>
	</div>
</template>

<script>
import Banner from "../components/Banner";
import ServicesProcess from "../components/ServicesProcess";
import ServicesBackgroundBanner from "../components/ServicesBackgroundBanner";
export default {
	components: {
		Banner,
		ServicesProcess,
		ServicesBackgroundBanner,
	},
	data() {
		return {
			underlineText: "Services",
			headerText: "Offshore Service",
		};
	},
};
</script>

<style lang="scss" scoped>

@import "ServicesContent.scss";

</style>

